




































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSTable from '@/components/AMSTable.vue';
import AMSProductSelector from '@/components/AMSProductSelector.vue';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import request from '@/utils/request';
import { emptyRule, selectEmptyRule } from '@/utils/rules';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';

import { allStaff } from '@/api/staff';
import { getInstock, createOrEditInstock, getStockWarehouses } from '@/api/stock';
interface Product {
  productId?: string;
  quantity?: number;
}
interface Form {
  products?: Product[];
  number?: string;
  warehouseId?: string;
  type?: 'Purchase' | 'Profit' | ' Return' | ' Transfer' | ' Other';
  stockTime?: string;
  remark?: string;
  operatorId?: Number;
  id?: string;
  category?: 'In';
}
@Component({
  components: {
    'ams-table': AMSTable,
    'ams-product-selector': AMSProductSelector,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class StockDetail extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: '/inStock'
    },
    {
      text: '入库单',
      disabled: false,
      href: '/inStock'
    },
    {
      text: this.isEdit() ? '修改入库单' : '新增入库单',
      disabled: true
    }
  ];
  form: Form = {
    stockTime: new Date().toISOString().substr(0, 10),
    type: 'Purchase',
    category: 'In'
  };
  valid = false;

  rules = {
    operatorId: [selectEmptyRule('经办人')]
  };
  staffList: Array<any> = [];
  WarehousesList: Array<any> = [];
  typeList = [
    { value: 'Purchase', text: '采购入库' },
    { value: 'Profit', text: '盘盈入库' },
    { value: 'Return', text: '退货入库' },
    { value: 'Transfer', text: '调拨入库' },
    { value: 'Other', text: '其他入库' }
  ];
  headers = [
    { text: '序号', value: 'number', isSort: true, sortable: false },
    {
      text: '商品',
      value: 'name',
      render: (h: Function, param: any) => {
        return h(AMSSelectedProduct, {
          props: {
            items: param,
            selectedItems: this.products,
            isMoreBtn: true
          },
          on: {
            select: (value: Array<object>) => {
              this.products.splice(param.index, 1, ...value, { productDate: Date });
            },
            autoComplete: (value: Object) => {
              this.products.splice(param.index, 1, value, { productDate: Date });
            }
          }
        });
      },
      sortable: false
    },
    { text: '容量', value: 'capacity', sortable: false },
    {
      text: '入库数量',
      value: 'quantity',
      sortable: false,
      isInputNumber: {
        type: 'stockQuantity'
      }
    },
    {
      text: '限用日期',
      value: 'productionDate',
      isDatePicker: true
    },
    {
      text: '操作',
      value: 'actions',
      isActions: true,
      sortable: false
    }
  ];

  products: Array<Object> = [{}];
  selectedProduct: Array<Object> = [];
  stockTime: boolean = false;
  date = new Date().toISOString().substr(0, 10);
  maxDate = new Date().toISOString().substr(0, 10);
  isSaving = false;
  dialog = false;
  addloading: Boolean = false;
  isEdit() {
    return this.$route.query.isEdit;
  }
  get totalProducts() {
    return this.products.filter((p: any) => {
      return p.id;
    }).length;
  }
  plus(a: number, b: number) {
    return a + b;
  }
  get totalQuantity(): number {
    return this.products
      .map((item: any) => {
        return parseInt(item.quantity);
      })
      .filter((f: any) => {
        return f;
      })
      .reduce(this.plus, 0);
  }
  get isNoProduct() {
    let filters = this.products.filter((p: any) => {
      return p.id;
    });
    return filters.length == 0;
  }
  get isNoQuantity() {
    let error = false;
    this.products.forEach((p: any) => {
      if (p.id && !p.quantity) {
        error = true;
      }
    });
    return error;
  }

  created() {
    this.getStockWarehousesList();
    this.getStaff();
    this.getFormData();
  }
  mounted() {}

  getStockWarehousesList() {
    getStockWarehouses().then((data: any) => {
      this.WarehousesList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
      this.form.warehouseId = this.WarehousesList[0].id;
    });
  }
  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
      if (!this.$route.query.id) {
        this.form.operatorId = this.$store.state.user.staffId;
      }
    });
  }

  getFormData() {
    if (!this.$route.query.id) return;
    getInstock(this.$route.query.id.toString()).then((data: any) => {
      this.form = Object.assign({}, this.form, data);
      var products = data.products.map((p: any) => {
        return Object.assign({}, p, { productionDate: p.productionDate ? moment(p.productionDate).format('YYYY-MM-DD') : null });
      });
      this.products.splice(0, 1, ...products);
      this.form.stockTime = moment(data.stockTime).format('YYYY-MM-DD');
    });
  }

  queryProduct(index: number, key: string) {
    this.dialog = true;
  }
  add(index: number, key: string) {
    //入库无限制
    this.products.splice(index + 1, 0, {});
  }
  remove(index: number, key: string) {
    this.products.splice(index, 1);
    if (this.products.length < 1) {
      this.products.push({});
    }
  }
  textChange(list: Array<object>) {
    this.products = list;
  }
  cancel() {
    this.dialog = false;
  }
  sure() {
    this.dialog = false;
  }
  back() {
    this.$router.go(-1);
  }
  save() {
    if (this.isNoProduct) {
      AppStore.ShowError(`请选择商品`);
      return;
    }
    if (this.isNoQuantity) {
      AppStore.ShowError(`入库数量不能为空`);
      return;
    }

    if (!this.isNoQuantity && !this.isNoProduct) {
      this.isSaving = true;
      this.addloading = true;
      let formData = Object.assign({}, this.form, {
        products: this.products
          .filter((f: any) => f.id)
          .map((p: any) => {
            return { productId: p.id, quantity: p.quantity, productionDate: p.productionDate };
          })
      });
      createOrEditInstock(formData)
        .then((data: any) => {
          this.addloading = false;
          this.$router.push({ name: 'inStock' });
        })
        .catch((err: any) => {})
        .finally(() => {
          this.addloading = false;
          this.isSaving = false;
        });
    }
  }
}
